import React, { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { bootstrapTitleMapping, docComponents, generalTitleMapping } from './DocumentationSidebarData';

import CommonHeader from '../../../Common/CommonHeader/CommonHeader';

const Documentation = ({
    themeMode,
    themeColor,
    borderStroke,
    boxLayout,
    monochrome,
    borderRadius,
    gradientColor,
}) => {

    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    const [isDocsHeadVisible, setIsDocsHeadVisible] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarHidden(!isSidebarHidden);

        // Check window width and toggle the docs head visibility
        if (window.innerWidth >= 992) {
            setIsDocsHeadVisible((prev) => !prev);
        }
    };

    const location = useLocation();
    const pathname = location.pathname;
    const docTitle = generalTitleMapping[pathname] || bootstrapTitleMapping[pathname] || "";

    return (
        <div
            data-theme={`theme-${themeColor}`}
            data-bs-theme={themeMode}
            className={`main_body ${gradientColor} ${borderStroke} ${boxLayout} ${monochrome} ${borderRadius} ${isSidebarHidden ? "sidebar-hide" : ""}`}
        >
            <main className={`${boxLayout === "box-layout"
                ? "container"
                : "container-fluid"
                } px-0 ${isSidebarHidden ? "sidebar-hide" : ""}`} >

                {/* // x---------------------------------x start: page menu link x---------------------------------x */}
                <aside id="sidebar" className="sidebar sticky-top d-lg-block" data-bs-theme="theme-FrenchRose">
                    <nav className="navbar  py-0 d-flex">
                        {/* // x---------------------------------x Asidebar Top Logo x---------------------------------x */}
                        <ul className="list-unstyled mb-2 py-1 w-100">
                            <li>
                                <div className="d-flex justify-content-between align-items-center ">
                                    <Link to="/" className="d-flex align-items-center logo">
                                        <svg className="me-2 text-primary" width="36" height="36"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M3 21l18 0" />
                                            <path d="M3 10l18 0" />
                                            <path d="M5 6l7 -3l7 3" />
                                            <path d="M4 10l0 11" />
                                            <path d="M20 10l0 11" />
                                            <path d="M8 14l0 3" />
                                            <path d="M12 14l0 3" />
                                            <path d="M16 14l0 3" />
                                        </svg>
                                        <span className="mb-0 mt-1 title-font h3 text-primary ">DashBanker</span>
                                    </Link>
                                    <button className="btn   border-0 p-0 pe-2 sidebar-docs-toggle-btn d-lg-none" onClick={toggleSidebar} type="button">
                                        <span className="no-thumbnail avatar md rounded-circle ">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1"
                                                strokeLinecap="round" strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right-from-arc">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                <path d="M15 12h-12"></path>
                                                <path d="M7 8l-4 4l4 4"></path>
                                                <path d="M12 21a9 9 0 0 0 0 -18"></path>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </li>
                        </ul>

                        {/* // x---------------------------------x Tabs x---------------------------------x */}
                        <div className=" py-3 ps-4">
                            <ul className="nav nav-pills ps-1 my-1   py-1  border rounded" id="pills-tab" role="tablist">
                                {/* <!--=== General tab button ===--> */}
                                <li className="nav-item me-2" role="presentation">
                                    <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                                        aria-selected="true">General</button>
                                </li>
                                {/* <!--===Bootstrap tab button  ===--> */}
                                <li className="nav-item me-2" role="presentation">
                                    <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-profile" type="button" role="tab"
                                        aria-controls="pills-profile" aria-selected="false">Bootstrap</button>
                                </li>
                            </ul>
                        </div>

                        {/* // x---------------------------------x Tabs Contant x---------------------------------x */}
                        <div className="tab-content w-100" id="pills-tabContent">
                            {/* <!--=== General tab Contant ===--> */}
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                {/* <!--============== nav link  =============--> */}
                                <ul className="list-unstyled mb-4 menu-list-override w-100">
                                    {/* <!--=== Documentation ===--> */}
                                    <li>
                                        <NavLink to="/docs/documentation" className="nav-link ps-1 my-1 active"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Dashboard"
                                            data-bs-original-title="Dashboard">
                                            <span className="mx-3">Documentation</span>
                                        </NavLink>
                                    </li>

                                    {/* <!--=== Basic Card ===--> */}
                                    <li>
                                        <NavLink to="/docs/widgets-basic-card" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Investments"
                                            data-bs-original-title="Investments">
                                            <span className="mx-3">Basic Card</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== Credit Title ===--> */}
                                    <li>
                                        <NavLink to="/docs/widgets-card-tiles" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right"
                                            aria-label="Credit Title" data-bs-original-title="Credit Cards">
                                            <span className="mx-3">Card Title</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== Tablbed Card ===--> */}
                                    <li>
                                        <NavLink to="/docs/widgets-card-tab" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Loans"
                                            data-bs-original-title="Loans">
                                            <span className="mx-3">Tablbed Card</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== Tables Example ===--> */}
                                    <li>
                                        <NavLink to="/docs/widgets-tables" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Services"
                                            data-bs-original-title="Services">
                                            <span className="mx-3">Tables Example</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--===Forms Example  ===--> */}
                                    <li>
                                        <NavLink to="/docs/widgets-forms" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right"
                                            aria-label="My Privileges" data-bs-original-title="My Privileges">
                                            <span className="mx-3">Forms Example</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== Apex Chart ===--> */}
                                    <li>
                                        <NavLink to="/docs/apex-chart" className="nav-link ps-1 my-1" data-bs-toggle="tooltip"
                                            data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Apex Chart</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== peity  =============--> */}
                                    <li>
                                        <NavLink to="/docs/peity" className="nav-link ps-1 my-1" data-bs-toggle="tooltip"
                                            data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">peity</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== datatables =============--> */}
                                    <li>
                                        <NavLink to="/docs/datatables" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">datatables</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== flatpickr =============--> */}
                                    <li>
                                        <NavLink to="/docs/flatpickr" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">flatpickr</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== inputmask =============--> */}
                                    <li>
                                        <NavLink to="/docs/inputmask" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">inputmask</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== jsvectormap =============--> */}
                                    <li>
                                        <NavLink to="/docs/jsvectormap" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">jsvectormap</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== sortablejs =============--> */}
                                    <li>
                                        <NavLink to="/docs/sortablejs" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">sortablejs</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== sweetalert2 =============--> */}
                                    <li>
                                        <NavLink to="/docs/sweetalert2" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">sweetalert2</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== tiny-slider =============--> */}
                                    <li>
                                        <NavLink to="/docs/tiny-slider" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">tiny-slider</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Calendar =============--> */}
                                    <li>
                                        <NavLink to="/docs/react-big-calendar" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">calendar</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== summernote =============--> */}
                                    <li>
                                        <NavLink to="/docs/summernote" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">summernote</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Bootstrap icon =============--> */}
                                    <li>
                                        <NavLink to="/docs/bootstrap-icon" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Bootstrap icon</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Flag icon =============--> */}
                                    <li>
                                        <NavLink to="/docs/flag-icon" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Flag Icon</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Fontawesome Icon =============--> */}
                                    <li>
                                        <NavLink to="/docs/fontawesome-icon" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Fontawesome Icon</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== linear icon =============--> */}
                                    <li>
                                        <NavLink to="/docs/linear-icon" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">linear icon</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        {/* <!--==============weather icon =============--> */}
                                        <NavLink to="/docs/weather-icon" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">weather icon</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                            {/* <!--===Bootstrap tab Contant  ===--> */}
                            <div className="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab">
                                {/* <!--============== nav link  =============--> */}
                                <ul className="list-unstyled mb-4 menu-list-override w-100">
                                    {/* <!--=== Accordion ===--> */}
                                    <li>
                                        <NavLink to="/docs/accordion" className="nav-link ps-1 my-1 active"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Dashboard"
                                            data-bs-original-title="Dashboard">
                                            <span className="mx-3">Accordion</span>
                                        </NavLink>
                                    </li>

                                    {/* <!--=== Alerts ===--> */}
                                    <li>
                                        <NavLink to="/docs/alerts" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Investments"
                                            data-bs-original-title="Investments">
                                            <span className="mx-3">Alerts</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== User Avatar ===--> */}
                                    <li>
                                        <NavLink to="/docs/avatar" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right"
                                            aria-label="Credit Title" data-bs-original-title="Credit Cards">

                                            <span className="mx-3">User Avatar</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--=== Badges  ===--> */}
                                    <li>
                                        <NavLink to="/docs/badges" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Loans"
                                            data-bs-original-title="Loans">
                                            <span className="mx-3">Badges</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--===  Breadcrumb ===--> */}
                                    <li>
                                        <NavLink to="/docs/breadcrumb" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Services"
                                            data-bs-original-title="Services">
                                            <span className="mx-3">Breadcrumb</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--===Buttons   ===--> */}
                                    <li>
                                        <NavLink to="/docs/buttons" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right"
                                            aria-label="My Privileges" data-bs-original-title="My Privileges">
                                            <span className="mx-3">Buttons</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--===Cards  ===--> */}
                                    <li>
                                        <NavLink to="/docs/cards" className="nav-link ps-1 my-1" data-bs-toggle="tooltip"
                                            data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Cards</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== carousel  =============--> */}
                                    <li>
                                        <NavLink to="/docs/carousel" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Carousel</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== collapse =============--> */}
                                    <li>
                                        <NavLink to="/docs/collapse" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">collapse</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Dropdowns =============--> */}
                                    <li>
                                        <NavLink to="/docs/dropdowns" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Dropdowns</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== listgroup =============--> */}
                                    <li>
                                        <NavLink to="/docs/listgroup" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Listgroup</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Modal =============--> */}
                                    <li>
                                        <NavLink to="/docs/modal" className="nav-link ps-1 my-1" data-bs-toggle="tooltip"
                                            data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Modal</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Navbar =============--> */}
                                    <li>
                                        <NavLink to="/docs/navbar" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Navbar</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Navs and tabs =============--> */}
                                    <li>
                                        <NavLink to="/docs/navstabs" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Navs and tabs</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Offcanvas =============--> */}
                                    <li>
                                        <NavLink to="/docs/offcanvas" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Offcanvas</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Pagination =============--> */}
                                    <li>
                                        <NavLink to="/docs/pagination" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Pagination</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Placeholders =============--> */}
                                    <li>
                                        <NavLink to="/docs/placeholders" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Placeholders</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Popovers =============--> */}
                                    <li>
                                        <NavLink to="/docs/popovers" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Popovers</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Progress =============--> */}
                                    <li>
                                        <NavLink to="/docs/progress" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Progress</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Spinners =============--> */}
                                    <li>
                                        <NavLink to="/docs/spinners" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Spinners</span>
                                        </NavLink>
                                    </li>
                                    {/* <!--============== Toasts =============--> */}
                                    <li>
                                        <NavLink to="/docs/toasts" className="nav-link ps-1 my-1"
                                            data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Setting"
                                            data-bs-original-title="Setting">
                                            <span className="mx-3">Toasts</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </aside>
                <div className="container-fluid">
                    <div className="docs">
                        {/* // x---------------------------------x CommonHeader Section x---------------------------------x */}
                        <CommonHeader hideValue={isDocsHeadVisible} MenuShow={false} dynamicClass={"sidebar-docs-toggle-btn"} toggleSidebar={toggleSidebar} toggleSidebarMobile={toggleSidebar} />
                        <div className="px-2 py-sm-3 py-1 page-body">
                            {/* // x---------------------------------x Main Documentation Section x---------------------------------x */}
                            {docComponents[docTitle]}
                        </div>
                    </div>
                </div>
            </main>
        </div >
    )
}

export default Documentation